
import featureService from '@/api/featureConfigService'



const state = {


    features: [],
    newFeature: {},
    edit: false
}
const getters = {

    featureData: state => state.features,
    newFeature: state => state.newFeature,
    edit: state => state.edit

};

const actions = {

    async addFeature({ commit, rootState }, feature) {
        await featureService.addFeature(feature)
        rootState.features.push(feature)
        commit('add', feature)
    },
    editFeature({ commit }, feature) {
        commit('edit', feature)
    },
    async updateFeature({ commit }, feature) {
        await featureService.updateFeature(feature.id, feature)
        commit('update', feature)
    },
    async removeFeature({ commit, rootState }, feature) {
        console.log("feature", feature.id)
        await featureService.removeFeature(feature.id)
        var features = rootState.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
        commit('remove', feature.id)
    }
}
const mutations = {

    add(state, feature) {
        // console.log("feat", feature)
        state.features.push(feature);
        state.newFeature = {}
    },
    edit(state, feature) {
        state.editId = feature.id
        state.edit = true
        state.newFeature = feature
        // router.push({ name: "addFeature", params: { add: true } });
    },
    update(state, feature) {
        var features = state.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
        features.push(feature);


    },
    remove(state, feature) {
        var features = state.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
    },
    cancel(state) {
        state.newFeature = {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}